import React from 'react'
import { Tab, TabContainer, SecondaryTab, SectionTabContainer } from './TabStyles'
import styled from 'styled-components'
import { useTabContext } from './TabContext'

export const Tabs = ({ fullWidth = false }: { fullWidth?: boolean }) => {
  const { activeTab, setActiveTab, tabs } = useTabContext()
  return (
    <TabContainer>
      {tabs.map((tab) => (
        <Tab
          fullWidth={fullWidth}
          key={tab}
          active={activeTab === tab}
          onClick={() => setActiveTab(tab)}
          textContent={tab}
        >
          {tab}
        </Tab>
      ))}
    </TabContainer>
  )
}

export const SectionTabs = () => {
  const { activeTab, setActiveTab, tabs } = useTabContext()
  return (
    <SectionTabContainer>
      {tabs.map((tab) => (
        <SecondaryTab
          active={activeTab === tab}
          textContent={tab}
          onClick={() => setActiveTab(tab)}
          key={tab}
        >
          {tab}
        </SecondaryTab>
      ))}
    </SectionTabContainer>
  )
}
